import { XStack } from '@/components/ui';
import { Widget } from '@/features/widgets/widget.parts';

import type { HomeSectionId } from '../home-preferences.store';
import type { ReactNode } from 'react';

const FEED_SECTION_ID: HomeSectionId = 'feed';

type FeedSectionProps = {
  readonly count?: string;
  readonly actions?: ReactNode;
  readonly onOpenFeed?: () => void;
  readonly collapsible?: boolean;
  readonly children: ReactNode;
};

export const FeedSection = ({
  count,
  actions,
  onOpenFeed,
  collapsible,
  children,
}: FeedSectionProps) => (
  <Widget id={FEED_SECTION_ID} collapsible={collapsible}>
    <Widget.Header
      title="Feed"
      count={count}
      accessory={
        <XStack className="items-center gap-1">
          {actions}
          {onOpenFeed ? (
            <Widget.HeaderButton onClick={onOpenFeed}>
              Open Feed
            </Widget.HeaderButton>
          ) : null}
        </XStack>
      }
    />
    <Widget.Body className="px-2">{children}</Widget.Body>
  </Widget>
);
